import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20illustration%20with%20multiple%20comic%20characters%20in%20dynamic%20poses%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20flowing%20ink%20and%20speed%20lines%20effect%2C%20dramatic%20cinematic%20lighting%2C%20artist%20colorful%20comic%20art%20background%2C%20soft%20gradient%20overlay%2C%20no%20text&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="韩漫画网 - 韩国漫画大全"
          title="韩漫画网 - 下拉式免费漫画在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4">
        <p className="text-sm md:text-base text-white/70 font-label tracking-widest mb-4">
          下拉式免费漫画 &middot; 韩漫在线观看 &middot; 韩国漫画大全
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-3xl mx-auto">
          发现最精彩的
          <span className="block font-heading italic text-primary-300">韩国漫画世界</span>
        </h1>
        <p className="mt-5 text-sm md:text-base text-white/60 max-w-xl mx-auto leading-relaxed">
          涵盖恋爱、热血、奇幻、悬疑等全类型韩国漫画，下拉式流畅阅读体验，随时随地畅享韩漫精彩内容
        </p>
        <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-background-50 text-foreground-900 font-medium rounded-full hover:bg-white transition-colors whitespace-nowrap text-sm"
          >
            立即浏览
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/30 text-white font-medium rounded-full hover:bg-white/10 transition-colors whitespace-nowrap text-sm"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-white/50 text-sm">
          <div className="text-center">
            <div className="text-2xl font-bold text-white">12+</div>
            <div className="text-xs mt-1">漫画分类</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-white">2000+</div>
            <div className="text-xs mt-1">漫画资源</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-white">500万+</div>
            <div className="text-xs mt-1">月活用户</div>
          </div>
        </div>
      </div>
    </section>
  );
}